import style from "../../../../assets/scss/common/modal/addChildModal.module.scss";
import React from "react";
import {useTranslation} from "react-i18next";
interface Args{
    label: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
}
export function AddressInput({label, name, value,onChange,placeholder}:Args) {
    const { t } = useTranslation("profileInfo");
    return (
        <>
        <span className={style.infoText}>
            <span className={style.optionalText}>
                {t('profileInfo.addModal.optional')}
            </span> {label}
        </span>
            <input
                name={name}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={style.inputField}
            />
        </>
    )
}